import { useThumbnailForSegment } from '../hooks/useThumbnailForSegment';
import { generateFallbackThumbnailDisplayInfo } from '../utils';
import { LoadingThumbnail } from './LoadingThumbnail';
import { PreloadedThumbnail } from './PreloadedThumbnail';

interface Props {
  stationId: string;
  segmentId: number;
  offsetSeconds?: number;
  animated?: boolean;
  theme?: 'dark' | 'light';
  targetHeight?: number;
}

export function SegmentThumbnail({
  stationId,
  segmentId,
  animated,
  offsetSeconds = 0,
  theme = 'light',
  targetHeight,
}: Props) {
  const thumb = useThumbnailForSegment(stationId, segmentId);

  // Only show loader if we don't have any thumbnail data (initial load)
  // When segmentId changes, placeholderData keeps the previous thumbnail visible
  if (thumb.isLoading && !thumb.info) {
    return (
      <LoadingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        theme={theme}
        targetHeight={targetHeight}
      />
    );
  }

  if (!thumb.info) {
    return null;
  }

  const displayInfo = {
    url: thumb.info.thumbnailUrl,
    metadata: thumb.info.metadata ?? generateFallbackThumbnailDisplayInfo(),
    offset: offsetSeconds,
  };

  return (
    <PreloadedThumbnail
      {...displayInfo}
      animated={animated}
      theme={theme}
      targetHeight={targetHeight}
    />
  );
}
